/**
 * General helper methods for react
 */
export default class ReactTools {
	/**
	 * General reducer to use with core
	 */
	public static generalReducer(state: any, action: ReducerAction): any {
		var result = state;
		switch (action.type) {
		case 'setGameManager':
			result = {...state, gameManager: action.value};
			break;
		case 'playSequence':
			state.gameManager.environment.playSequence(action.value);
			break;
		}
		return result;
	}
	
}

export interface ReducerAction {
    type: string;
    value: any;
}